import React from "react";
import { observer } from "mobx-react";
import styles from "./styles.module.css";

class InputStatic extends React.Component {
  render() {
    const {
      store,
      id,
      label,
      inputWidth = "",
      labelWidth = "",
      formGroupAdd = [],
      // options,
      name,
      // placeholder,
      // onChange,
      // onKeyPress,
      value,
      // type,
      // animatedLabel = true,
      ignoreValueStyles = false,
    } = this.props;

    const valueFinal = store && store.data ? store.get(name) : value;

    return (
      <div>
        {label && (
          <label htmlFor={id} className={["control-label", labelWidth, styles.labelUnactive].join(" ")}>
            <span className={styles.labelText}>{label || name}</span>
            <span className={styles.labelBackground} />
          </label>
        )}

        <div className={inputWidth}>
          <div style={ignoreValueStyles ? {} : { position: "relative", top: 6 }}>
            {String(valueFinal).match("@") ? <a href={`mailto:${valueFinal}`}>{valueFinal}</a> : valueFinal}
          </div>
        </div>

        {formGroupAdd}

        {store && store.errors && store.errors[name] && (
          <p className={styles.error}>
            <small>{store.errors[name]}</small>
          </p>
        )}
      </div>
    );
  }
}
// ref={instance => (this.input = instance)}

export default observer(InputStatic);
